import ExecutionTicketEntry from './ExecutionTicketEntry';

const ModelRendererComponents = {
    ExecutionTicketEntry,
};

export default ModelRendererComponents;
